import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {ButtonTheme} from 'common/components/button/constants';
import {getEntityType, promptSuperadminOverrideShare} from 'common/report/util/saved-entities';
import {panel2react} from 'common/util/react';
import {IronContextRegistry} from 'common/report/context-registry';

import {sharingUtils} from '../utils';
import {sharingWidget} from '../index';
import {SharingButtonAttrs, SharingButtonState} from './types';
import {template} from './template';

export class SharingButton extends Component<SharingButtonState, SharingButtonAttrs, TODO, TODO, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<SharingButtonAttrs> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      theme: {type: `string`, enum: Object.values(ButtonTheme), default: ButtonTheme.Secondary},
      type: `string`,
      id: `number`,
      'project-id': `number`,
      'display-override-confirmation': `boolean`,
    };
  }

  get config() {
    return {
      template,
      contexts: [`i18n` as const],
      defaultState: {
        modalOpen: false,
      },
      helpers: {
        handleClick: () => {
          this.openShareModal();
        },
        isDisabled: () =>
          this.attr(`disabled`) ||
          !sharingUtils.validateSharingAttributes({
            projectId: this.attr(`project-id`),
            id: this.attr(`id`),
            type: this.attr(`type`),
          }) ||
          this.state.modalOpen,
      },
    };
  }

  private async openShareModal() {
    this.update({modalOpen: true});

    if (
      this.attr(`display-override-confirmation`) &&
      !(await promptSuperadminOverrideShare(getEntityType(this.attr(`type`)), {i18n: this.getContext(`i18n`)}))
    ) {
      this.update({modalOpen: false});
      return;
    }

    await sharingWidget.promptSharing({
      type: this.attr(`type`),
      id: this.attr(`id`),
      'project-id': this.attr(`project-id`),
    });
    this.update({modalOpen: false});
  }
}

export const SharingButtonEl = defineAndMakeJsxFactory(`mp-sharing-button`, SharingButton);
export const SharingButtonReact = panel2react<{attrs: Partial<SharingButtonAttrs>}>(`mp-sharing-button`, SharingButton);
